import './NotificationBanner.scss';
import cn from 'classnames';
import { ReactNode } from 'react';
import { MdInfo, MdWarning } from 'react-icons/md';
import { Intent, IntentType } from '@Components/designConstants';

interface NotificationBannerProps {
  intent?: IntentType;
  message: ReactNode;
}

export const NotificationBanner = ({ intent = Intent.INFO, message }: NotificationBannerProps) => (
  <div className={cn('notification-banner', { warning: intent === Intent.WARNING })}>
    <div className='notification-banner-icon'>
      {intent === Intent.WARNING ? <MdWarning /> : <MdInfo />}
    </div>
    <span className='notification-banner-text'>{message}</span>
  </div>
);
